module.exports = __webpack_public_path__ + "img/fastfood.536a092e.svg";